import { format as formatDate } from 'date-fns';
import { OnboardingRegistrationStatus, RegistrationStatus } from '../viewModels/Enums';
import { RegistrationDetailsFormDataCloudAccount } from '../viewModels/registrationDetails/form/data/RegistrationDetailsFormDataCloudAccount';
import { OnboardingRegistrationOdinAccount, OnboardingRegistration, CreateNewOdinAccount, TenantDetailsApi } from '../models';
import { RegistrationDetailsFormData } from '../viewModels/registrationDetails/form/data/RegistrationDetailsFormData';
import { RegistrationDetailsOdinRefresh } from '../viewModels/registrationDetails';
import { RegistrationDetailsFormDataNewCloudAccount } from '../viewModels/registrationDetails/form/data/RegistrationDetailsFormDataNewCloudAccount';
import { TenantDetailsFormDataTenant } from '../viewModels/tenantDetails/form/data/TenantDetailsFormDataTenant';

export class RegistrationsHelper {

    static formatDate(dateAsUtcString: string): string {
        return formatDate(dateAsUtcString, 'DD-MMM-YYYY h:mmA');
    }

    static formatStatus(status: OnboardingRegistrationStatus): string {
        const statusMap: Map<OnboardingRegistrationStatus, RegistrationStatus> = new Map<OnboardingRegistrationStatus, RegistrationStatus>(
            [
                [OnboardingRegistrationStatus.Submitted, RegistrationStatus.New],
                [OnboardingRegistrationStatus.Pending, RegistrationStatus.InProgress],
                [OnboardingRegistrationStatus.Error, RegistrationStatus.Failed],
                [OnboardingRegistrationStatus.Cancelled, RegistrationStatus.Cancelled],
                [OnboardingRegistrationStatus.Completed, RegistrationStatus.Completed],
            ],
        );

        const registrationStatus: RegistrationStatus | undefined = statusMap.get(status);

        return registrationStatus ? registrationStatus : '';
    }

    static mapOdinAccountToExistingCloudAccount(cloudAccount: RegistrationDetailsFormDataCloudAccount, onboardingRegistrationOdinAccount: OnboardingRegistrationOdinAccount): void {
        Object.assign(cloudAccount, {
            authorisedPurchaserEmail: onboardingRegistrationOdinAccount.authorisedPurchaserEmail,
            ban: onboardingRegistrationOdinAccount.ban,
            companyName: onboardingRegistrationOdinAccount.companyName,
            registrationId: onboardingRegistrationOdinAccount.registrationId,
            cidn: onboardingRegistrationOdinAccount.cidn,
        });
    }

    static getUpdateOnboardingRegistration(onboardingRegistration: OnboardingRegistration, data: RegistrationDetailsFormData): OnboardingRegistration {
        return {
            ...onboardingRegistration,
            name: data.customer.name,
            phone: data.customer.phone,
            tenantName: data.customer.tenantName,
            odinAccountId: data.cloudAccount.accountId,
        };
    }

    static getOdinRefresh(onboardingRegistration?: OnboardingRegistration): RegistrationDetailsOdinRefresh {
        const isVisible: boolean = onboardingRegistration ? [OnboardingRegistrationStatus.Error, OnboardingRegistrationStatus.Submitted].indexOf(onboardingRegistration.status) >= 0 : false;
        const isDisabled: boolean = onboardingRegistration ? onboardingRegistration.isOdinSyncInProgress || onboardingRegistration.isOdinCreationInProgress : false;
        return {
            isVisible,
            isDisabled,
        };
    }

    static getCreateOdinAccount(newCloudAccount: RegistrationDetailsFormDataNewCloudAccount): CreateNewOdinAccount {
        return {
            companyName: newCloudAccount.companyName,
            companyAddressLine1: newCloudAccount.companyAddressLine1,
            companyAddressLine2: newCloudAccount.companyAddressLine2,
            companyAddressCity: newCloudAccount.companyAddressCity,
            companyAddressPostCode: newCloudAccount.companyAddressPostCode,
            companyAddressState: newCloudAccount.companyAddressState,
            companyAddressCountryCode: newCloudAccount.companyAddressCountryCode,
            administrativeContactFirstName: newCloudAccount.administrativeContactFirstName,
            administrativeContactLastName: newCloudAccount.administrativeContactLastName,
            administrativeContactPhone: newCloudAccount.administrativeContactPhone,
            administrativeContactEmail: newCloudAccount.administrativeContactEmail,
            billingAccountNumber: newCloudAccount.billingAccountNumber,
            customerIdentificationNumber: newCloudAccount.customerIdentificationNumber,
        };
    }

}
